export const LANG = {
  SUCCESS: "Success!",
  ERROR: "Error!",
  APIERROR: "Oops! Something went wrong there, Please try again.",
  FORGETPASSWORD: "Password successfully sent to the email",
  FIELD: "field",
  SEPARATOR: "separator",
  HEADING: "heading",
  CONFIGURATION: "configuration",
  NUMBER: "number",
  FIELD_TYPES: {
    boolean: "Boolean",
    checkbox: "Checkbox",
    date: "Date",
    dropdown: "Dropdown",
    email: "Email",
    numeric: "Numeric",
    radio: "Radio",
    rating: "Rating",
    text: "Text",
    textarea: "Textarea",
  },
  COL: {
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    10: 10,
    11: 11,
    12: 12,
  },
  DEFAULT_COL: 4,
  BASE64: "base64",
  IMAGE_JPEG: "image/jpeg",
  EXCEL: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  CANCEL: "Cancel",
  REMOVE: "Remove",
  CONFIRM_TO_REMOVE: "Confirm to remove",
  ARE_YOU_SURE_YOU_WANT_TO_DO_THIS: "Are you sure to do this.",
};
